import { useKestrel } from 'features/kestrelViewer'
import { GenericEditButton } from 'features/kestrelViewer/kestrelViewerMarkup/utils/GenericEditButton'
import React, { FC } from 'react'
import { Vector2 } from 'three'
import { KVAnnotation } from 'types'

export const EditAnnotationButton: FC<{
  annotation: KVAnnotation
}> = ({ annotation }) => {
  const { setPopupMenuStartPosition, setSelectedMarkup } = useKestrel()

  const handleEdit = () => {
    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(80, 20))
    }
    setSelectedMarkup(annotation)
  }

  return (
    <GenericEditButton
      itemId={annotation.id}
      tooltipLabel='Edit annotation'
      onEdit={handleEdit}
    />
  )
}
